export const fillText = (text, vals) =>
  text.replace(/\[(Name|Your Name|Church)\]/g, (m, k) => (vals[k] || "").trim() || m);

export const smsHref = (phone, body) => {
  const num = (phone || "").replace(/[^\d+]/g, "");
  return `sms:${num}?&body=${encodeURIComponent(body)}`;
};

export const myFirstName = (user) => (user?.name || "").trim().split(/\s+/)[0] || "";

export const NS_MISSED_CLASS_TEXTS = [
  { id: "ns-missed-1", title: "Missed this week's class", text: "Hey [Name]! It’s [Your Name] from [Church]. We missed you in Next Steps class this week! I hope everything is okay. Want me to catch you up on what we covered?" },
  { id: "ns-missed-2", title: "Missed a couple of classes", text: "Hey [Name], this is [Your Name]. I noticed you’ve missed the last couple of Next Steps classes and wanted to check on you. Is everything alright? Is there anything I can be praying about for you?" },
  { id: "ns-missed-3", title: "Inviting them back", text: "Hey [Name]! It’s [Your Name] from [Church]. Just a reminder that Next Steps class is this week, and we’d love to have you back. Want me to save you a seat?" },
];
